import shopQueries from '@apis/queries/shopQueries';
import useCurrency from '@hooks/item/useCurrency';
import { ItemResponse } from '@models/item';
import { useActivity } from '@stackflow/react';
import { useQuery } from '@tanstack/react-query';
import { itemToGtmFormat, pushEcommerceEvent } from '@utils/gtm';
import { useEffect } from 'react';

function useViewItem(item?: ItemResponse) {
    const { params } = useActivity();
    const currency = useCurrency();
    const shopId = params?.shopId;
    const { data: shop } = useQuery({
        ...shopQueries.detail(shopId as string),
        enabled: typeof shopId === 'string',
    });
    return useEffect(() => {
        if (item && shop) {
            pushEcommerceEvent('view_item', {
                value: item.id,
                currency,
                items: [itemToGtmFormat({ item, shop })],
            });
        }
    }, [item, shop, currency]);
}

export default useViewItem;
